import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';

import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { EmailQuoteService, MLResponsysService } from 'gw-capability-quoteandbind';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import appConfig from 'app-config';

import messages from './MLFooterSubmissionInfoComponent.messages';
import styles from './MLFooterSubmissionInfoComponent.module.scss';


import { Button, RadioButtonField, InputField, InputMaskField } from '@jutro/legacy/components';


const MLFooterSubmissionInfoComponent = (props) => {
    const modalApi = useModal();
    const translator = useTranslator();
    const {
        submissionFound,
        quoteID,
        sessionUUID,
        submissionStatus,
        emailAddress1,
        phoneNumber,
        isOnQBContactDetails,
        policyNumber,
        location
    } = props;

    const [selected, setSelected] = useState('email');
    const [email, setEmail] = useState(emailAddress1);
    const [phone, setPhone] = useState(phoneNumber);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const ref = useRef(null);
    const isQnB = appConfig.portalCode === 'QB';

    useEffect(() => {
        setEmail(emailAddress1);
        setPhone(phoneNumber);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    const handleDocumentClick = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setPopoverVisible(false);
        }
    };

    const showPopover = () => {
        setPopoverVisible(true);
    };

    useEffect(() => {
        document.addEventListener('click', handleDocumentClick, true);
        return () => document.removeEventListener('click', handleDocumentClick, true);
    }, []);

    useEffect(() => {
        setEmail(emailAddress1);
    }, [emailAddress1]);

    useEffect(() => {
        setPhone(phoneNumber);
    }, [phoneNumber]);


    const prepareCall = () => {
        const QuoteEmailDto = {
            quoteID: quoteID,
            sessionID: sessionUUID,
            emailAddress1: selected === 'email' ? email : null,
            phoneNumber_ML: selected === 'text' ? phone : null,
            sendType_ML: selected,
            completedQuote_ML: isQnB ? true : false,
            overrideCustomerNotificationSettings_ML: true
        };
        return EmailQuoteService.emailQuote(QuoteEmailDto, false);
    };

    const clickSendQuote = () => {
        prepareCall()
            .then(() => {
                const modalBody = selected === 'email' ? messages.emailSent : messages.textSent;
                const target = selected === 'email' ? email : phone;

                setPopoverVisible(false);
                modalApi.showAlert({
                    title: translator(messages.thankyou),
                    message: <p>{translator(modalBody, { target })}</p>,
                    confirmButtonText: messages.continue,
                    status: 'success',
                });

                if (selected === 'email' && quoteID && submissionStatus !== 'Bound' && submissionStatus !== 'Binding') {
                    MLResponsysService.sendDataToResponsys(quoteID);
                }
            })
            .catch(_.noop);
    };

    const changeSelectedOption = (value) => {
        setSelected(value);
    };

    const changeEmail = (value) => {
        setEmail(value);
    };

    const changePhone = (value) => {
        setPhone(value);
    };

    if (isOnQBContactDetails || !submissionFound) {
        return (null);
    }

    if (submissionStatus !== 'Bound') {
        return (
            <div className={styles['saved-quote']}>
                <span className={styles['saved-quote-section-header']}>{translator(messages.savedQuote)}</span>
                <span className={styles['saved-quote-quote-number']}>{`#${quoteID}`}</span>
                <br />
                {/* <Button
                    id="footerOpenPopoverButton"
                    className={styles['saved-quote-send-button']}
                    onClick={showPopover}
                >
                    {translator(messages.sendQuote)}
                </Button> */}
                {popoverVisible
                    && (
                        // eslint-disable-next-line max-len
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                        (<div ref={ref} className={classNames('ml-popover__container footer-container', styles['footer-popover-container'])}>
                            <div className={`ml-popover pointer-left clearfix ${isQnB ? styles['send-email-container-width']:''}`}>
                                <div className="col-md-12">
                                    <RadioButtonField
                                        availableValues={isQnB ? [] : [
                                            {
                                                id: 'email',
                                                displayName: translator(messages.email)
                                            },
                                            {
                                                id: 'text',
                                                displayName: translator(messages.text)
                                            }
                                        ]}
                                        id="footerSendEmailOrTextRadioButton"
                                        label={isQnB ? translator(messages.sendQuoteEmail) : translator(messages.sendQuoteEmailOrText)}
                                        onValueChange={changeSelectedOption}
                                        required
                                        value={selected}
                                        isHorizontal
                                        className="vertical-spacing-20"
                                    />
                                    {selected === 'email' &&
                                        <InputField
                                            hideLabel
                                            id="footerSendQuoteEmailField"
                                            className={`vertical-spacing-20 ${isQnB ? styles['send-email-field-width'] : ''}`}
                                            maxLength={60}
                                            validator={{
                                                pattern: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}',
                                                message: translator(messages.validEmail),
                                            }}
                                            placeholder={translator(messages.email)}
                                            required
                                            onValueChange={changeEmail}
                                            value={email}
                                        />
                                    }
                                    {selected === 'text' &&
                                        <InputMaskField
                                            id="footerSendQuotePhoneNumber"
                                            className="vertical-spacing-20"
                                            hideLabel
                                            required
                                            alwaysShowMask
                                            mask="(999) 999-9999"
                                            maskChar="#"
                                            messageProps={{
                                                incompleteInput: {
                                                    id: 'ml.quoteandbind.common.PhoneNumberComponent.Enter a 10 digit phone number without dashes',
                                                    defaultMessage: 'Enter a 10 digit phone number without dashes'
                                                }
                                            }}
                                            onValueChange={changePhone}
                                            value={phone}
                                        />
                                    }
                                    <div className={styles['send-button-container']}>
                                        <Button
                                            id="footerSendEmailButton"
                                            onClick={clickSendQuote}
                                        >
                                            {translator(messages.send)}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                    )
                }
            </div>
        );
    }

    return (
        <div className={styles.submissionQuote}>
            <span><b>{translator(messages.policyNumber)}</b></span>
            <p>#{policyNumber}</p>
        </div>
    );
};

MLFooterSubmissionInfoComponent.defaultProps = {
    submissionFound: undefined,
    quoteID: undefined,
    sessionUUID: undefined,
    submissionStatus: undefined,
    emailAddress1: undefined,
    phoneNumber: undefined,
    isOnQBContactDetails: undefined,
    policyNumber: undefined
};

MLFooterSubmissionInfoComponent.propTypes = {
    submissionFound: PropTypes.bool,
    quoteID: PropTypes.string,
    sessionUUID: PropTypes.string,
    submissionStatus: PropTypes.string,
    emailAddress1: PropTypes.string,
    phoneNumber: PropTypes.string,
    isOnQBContactDetails: PropTypes.bool,
    policyNumber: PropTypes.string

};
export default MLFooterSubmissionInfoComponent;
